import axios from 'axios';
import React, { useState } from 'react'
import SecurityHeaders from '../../context/SecurityHeaders';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import { AccountCircle } from '@material-ui/icons';
import { Link } from 'react-bootstrap-icons';
import ENDPOINT from '../../context/EndPoint';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const AddMentor = () => {
  const navigation = useNavigate()
  const dispatch = useDispatch()
    const [profilePic, setProfilePic] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);

    const [onlineStatus, setOnlineStatus] = useState('active');
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [about, setabout] = useState(null);
    const [bio, setbio] = useState(null);
    const [experience, setexperience] = useState(null)
    const [linkedin, setlinkedin] = useState(null)
    const [skill_description, setskill_description] = useState(null)
    const [skill_title, setskill_title] = useState(null)
    const [skills, setskills] = useState(null)
    const [status, setstatus] = useState(null)
    const [trains_at, settrains_at] = useState(null)
    const [company_logo, setcompany_logo] = useState(null)
    const [cover_img, setcover_img] = useState(null)
    const [profile_pic, setprofile_pic] = useState(null)
    const [rating, setrating] = useState(null)
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        setProfilePic(file); // Store the file object directly
      }
    };
  
    const [open, setOpen] = useState({
      open: false,
      message: '',
      type: ''
  
    });
      const addmentor = async (e) => {
        e.preventDefault();
        dispatch({type:'LOADING'})
        const data = new FormData();
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (profilePic && profilePic.size > maxSize) {
            dispatch({ type: "ERROR", payload: "Image size must be less than 5MB." });
            return;
        }
       
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
     
        if ( profilePic && !allowedTypes.includes(profilePic.type)) {
            dispatch({ type: "ERROR", payload: "Only JPEG, PNG, or JPG images are allowed." });
            return;
        }
        if (profilePic) {
          data.append('profile_pic', profilePic); 
        }
        data.append('first_name', firstName);
        data.append('last_name', lastName);
        data.append('email', email);
        data.append('phone_num', phone); 
        data.append('status', onlineStatus || 'active'); // Default to 'active'
        data.append('about', about);
        data.append('bio', bio);
        data.append('experience', experience);
        data.append('linkedin', linkedin);
        data.append('skill_description', skill_description);
        data.append('skill_title', skill_title);
        data.append('skills', skills);
        data.append('status', status);
        data.append('trains_at', trains_at);
        data.append('company_logo', company_logo);
        data.append('cover_img', cover_img);
       
        data.append('rating', rating);
    
        try {

          const res = await axios.post(ENDPOINT+"add-mentor.php", data, SecurityHeaders);
          if (res.data.status === 'success') {
         navigation('/mentors')
         dispatch({type:'DONE_LOADING'})
            setOpen({ open: true, message: 'Team member added successfully!', type: 'success' });
          } else {
            dispatch({ message: res.data.message, type: 'ERROR' });
          }
        } catch (error) {
          dispatch({ message: error.message, type: 'ERROR' });
        }
      };
  return (
    <>
      <SnackbarToast open={open} handleClose={() => setOpen({ open: false })} />

         <div className="container d-flex justify-content-center">
              <div className="container card col-11 col-lg-8 col-sm-12 col-md-8 p-4 shadow rounded-3">
                <h2 className='mb-3'>Add Mentor</h2>
                <form onSubmit={addmentor}>
                  <div className="mb-3">
                    <label htmlFor="profilePic" className="form-label">Profile Picture</label>
                    <input type="file" accept='images/*' className="form-control" onChange={(e) => setProfilePic(e.target.files[0])} required />
                  
                  </div>  
                  <div className="mb-3">
                    <label htmlFor="firstName" className="form-label">First Name</label>
                    <input type="text" className="form-control" onChange={(e) => setFirstName(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">Last Name</label>
                    <input type="text" className="form-control" onChange={(e) => setLastName(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" className="form-control" onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input type="text" className="form-control" onChange={(e) => setPhone(e.target.value)} required />
                  </div>
               

                  <div className="mb-3">
                    <label htmlFor="category" className="form-label">About</label>
                    <input type="text" className="form-control" onChange={(e) => setabout(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="category" className="form-label">Bio</label>
                    <input type="text" className="form-control" onChange={(e) => setbio(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="experience" className="form-label">Experience</label>
                    <input type="text" className="form-control" onChange={(e) => setexperience(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">Skills</label>
                    <input type="text" className="form-control" onChange={(e) => setskills(e.target.value)} required />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">Linkedin</label>
                    <input type="text" className="form-control" onChange={(e) => setlinkedin(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">skill_description</label>
                    <input type="text" className="form-control" onChange={(e) => setskill_description(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">skill_title</label>
                    <input type="text" className="form-control" onChange={(e) => setskill_title(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">Status</label>
                    <input type="text" className="form-control" onChange={(e) => setstatus(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">trains_at</label>
                    <input type="text" className="form-control" onChange={(e) => settrains_at(e.target.value)} required />
                  </div>

                  
                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">Rating</label>
                    <input type="text" className="form-control" onChange={(e) => setrating(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">Cover Image</label>
                    <input type="text" className="form-control" onChange={(e) => setcover_img(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">Company Logo</label>
                    <input type="text" className="form-control" onChange={(e) => setcompany_logo(e.target.value)} required />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="onlineStatus" className="form-label">Online Status</label>
                    <input type="text" className="form-control" onChange={(e) => setOnlineStatus(e.target.value)} value={onlineStatus} />
                  </div>
                  <button type="submit" className="btn btn-primary">Add Mentor</button>
                </form>
              </div>
            </div>
    </>
  )
}

export default AddMentor
